import { Conditions } from "@pages/booking/Conditions";
import { useEffect } from "react";
import { Outlet, useSearchParams, useLocation } from "react-router";
import { Stepper } from "./Stepper";
import { routes } from "@routes";
import { useBookingStore } from "@stores/useBookingStore";
import { useFetchDap } from "@hooks/useFetchDap";

export function BookingHome() {
  const [searchParams] = useSearchParams();
  const { setOutwardOffer, setInwardOffer } = useBookingStore();
  const location = useLocation();
  const { dap, isLoading, fetchDap, errorDapMessage } = useFetchDap();

  // Routes pour lesquelles les conditions ne doivent pas être affichées
  const confirmationRoutes = [routes.CART, routes.CONFIRMATION, routes.PAYMENT];
  const shouldShowConditions = !confirmationRoutes.includes(location.pathname);

  useEffect(() => {
    fetchDap(searchParams.get("dap"), searchParams.get("dap_name"));
  }, [searchParams]);

  useEffect(() => {
    return () => {
      if (
        ![
          routes.RESULTS,
          routes.RECAP,
          routes.PLACEMENTS,
          routes.OPTIONS,
          routes.PASSPORT,
        ].includes(location.pathname)
      ) {
        setOutwardOffer(null);
        setInwardOffer(null);
      }
    };
  }, [location.pathname]);

  return (
    <div className="relative px-5 lg:px-0 mx-auto w-full">
      <Stepper />
      <div className="flex flex-col my-4 md:my-10 justify-center gap-4 lg:flex-row lg:gap-12 lg:my-20 w-full lg:px-5">
        {shouldShowConditions && <Conditions dap={dap} />}
        <div
          className={`max-w-[936px] w-full mt-20 md:mt-[180px] lg:mt-12 ${
            !shouldShowConditions ? "mx-auto" : ""
          }`}
        >
          <Outlet context={{ dap, isLoading, errorDapMessage }} />
        </div>
      </div>
    </div>
  );
}
